<script>
  export let params = {}

  const parseJson = async (response) => {
    const text = await response.text()
    try {
      const json = JSON.parse(text)
      return json
    } catch (err) {
      kalender = { kalenderid: 11, kalendernavn: "Graving", lag: [] }
    }
  }

  export let kalender = { kalenderid: 11, kalendernavn: "Graving", lag: [] }
  function getData() {
    const fetchPromise = fetch(
      `https://killingmoinfoapi.planleggern.no/Kalender/GetKalender/${params.type}`
    )
    kalender = fetchPromise.then(parseJson).then((data) => {
      kalender = data
    })
  }

  setInterval(function () {
    getData()
  }, 60 * 5000)
  function getStatusColor(status) {
    let color = ""
    switch (status) {
      case 0:
        color = "#fff"
        break
      case 3:
        color = "#eee"
        break
      case 4:
        color = "#ffe0b2"
        break
      case 6:
        color = "#82b4e1"
        break
      case 8:
        color = "#8ce68c"
        break
      case 9:
        color = "#e6988c"
        break
      case 11:
        color = "#eee"
        break
      default:
    }
    return color
  }
  function pickColor(bgColor, lightColor, darkColor) {
    var color = bgColor
      .replace(
        /^#?([a-f\d])([a-f\d])([a-f\d])$/i,
        (m, r, g, b) => r + r + g + g + b + b
      )
      .replace("#", "")
    var r = parseInt(color.substring(0, 2), 16) // hexToR
    var g = parseInt(color.substring(2, 4), 16) // hexToG
    var b = parseInt(color.substring(4, 6), 16) // hexToB
    var uicolors = [r / 255, g / 255, b / 255]
    var c = uicolors.map((col) => {
      if (col <= 0.03928) {
        return col / 12.92
      }
      return Math.pow((col + 0.055) / 1.055, 2.4)
    })
    var L = 0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2]
    return L > 0.179 ? darkColor : lightColor
  }

  var denneTimen = new Date().getHours()

  getData()
</script>

<style>
  .teams {
    display: flex;
    border: 3px solid #333;
    background: #333;
    height: 100vh;
  }

  .lagnavn {
    padding: 10px;
    border-bottom: 4px solid #111;
    text-align: center;
    font-size: 20px;
  }

  .team {
    flex-grow: 1;
    border-right: 3px solid #111;
  }
  .team:last-child {
    border-right: 0;
  }

  .team:last-child {
    margin-right: 0;
  }

  .oppdrag {
    padding: 10px;
    border-bottom: 1px solid #111;
    flex: 1 1 0px;
  }

  .kundenavn {
    font-style: italic;
    font-weight: bold;
    font-size: 14px;
  }

  .transport {
    font-weight: bold;
  }

  .opprettetav {
    font-weight: bold;
  }

  .klokke {
    font-style: italic;
    font-weight: bolder;
  }

  h1 {
    font-size: 16px;
    margin: 0;
  }
  .container {
    justify-content: space-between;
    display: flex;
  }
  .oppdrag.mod1 {
    background: #efefef;
  }
  .oppdrag.mod1:nth-child(2n + 3) {
    background: #fefefe;
  }
  .oppdrag.mod0 {
    background: #fefefe;
  }
  .oppdrag.mod0:nth-child(2n + 3) {
    background: #efefef;
  }
</style>

<!-- :style="{ background: l.lagfarge, color: '#fff' }"-->
<div class="teams">
  {#if kalender}
    {#if kalender.lag}
      {#each kalender.lag as l, index}
        <div class="team">
          <h1
            class="lagnavn"
            style="
		{kalender.lag.length > 9 ? 'font-size: 14px;' : ''}
	  background-color: {'#' + l.lagfarge};
	  color: {pickColor('#' + l.lagfarge, '#efefef', '#333')}">
            {l.lagnavn}
          </h1>
          <!--    antallkommentar: 0,
          antallbilder: 4,-->
          {#each l.oppdrag as o, i}
            <div
              class="oppdrag mod{index % 2} status{o.oppdragsstatus}"
              style="background-color: {getStatusColor(o.oppdragsstatus)}!important">
              <div
                class="container "
                style={kalender.lag.length > 9 ? 'flex-direction: column;font-size: 12px' : ''}>
                <div class="left">
                  <div class="kundenavn">{o.kundenavn}</div>
                  <div class="klokke">
                    {#if o.startklokke}<span>{o.startklokke}</span>{/if}
                    {#if o.sluttklokke}<span>{'-' + o.sluttklokke}</span>{/if}
                  </div>
                  <div class="adresse">
                    {#if o.adresse}<span>{o.adresse + ', '}</span>{/if}
                    {#if o.postnr}<span>{o.postnr}</span>{/if}
                    {#if o.poststed}<span>{o.poststed}</span>{/if}
                  </div>
                </div>
                <div
                  class="right"
                  style={kalender.lag.length > 9 ? 'flex-direction: row; display: flex;font-size: 12px' : ''}>
                  <div class="opprettetav">{o.opprettetavinitialer}</div>
                  {#if kalender.lag.length > 9}&nbsp;{/if}
                  <div class="transport">
                    {#if o.autoopprettettransportoppdrag}<span>T</span>{/if}
                    {#if kalender.lag.length > 9}&nbsp;{/if}
                    {#if o.autoopprettetfeieoppdrag}<span>F</span>{/if}
                    {#if kalender.lag.length > 9}&nbsp;{/if}
                    {#if o.autoopprettetavfresing}<span>Fresing</span>{/if}
                  </div>
                </div>
              </div>
            </div>
          {/each}
        </div>
      {/each}
    {/if}
  {/if}
</div>
